/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_CaptioningInputs */



/**
* | output |
* | --- |
* | "Automatic Captioning*" |
*
* @param {Signup_Compare_CaptioningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_captioning = /** @type {((inputs?: Signup_Compare_CaptioningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_CaptioningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Automatic Captioning*")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatic Captioning*")
	if (locale === "it") return /** @type {LocalizedString} */ ("Automatic Captioning*")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Automatic Captioning*")
	if (locale === "es") return /** @type {LocalizedString} */ ("Automatic Captioning*")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Automatic Captioning*")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Automatic Captioning*")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Automatic Captioning*")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Automatic Captioning*")
	return /** @type {LocalizedString} */ ("Automatic Captioning*")
});